import { useState, useEffect, useCallback } from "react";
import axiosInstance from "utilities/axios";

interface ApiResponse<T> {
  data: T | null;
  load: boolean;
  error: unknown;
  fetchData: () => void;
}

const useFetchData = <T>(
  url: string,
  setState?: (dt: T) => void,
  callback?: (...args: any[]) => void,
  ...rest: (string | number | boolean | null | undefined)[]
): ApiResponse<T> => {
  const [data, setData] = useState<T | null>(null);
  const [load, setLoad] = useState<boolean>(false);
  const [error, setError] = useState<unknown>(null);

  const fetchData = useCallback(async (): Promise<void> => {
    if (!url) return;

    setLoad(true);
    setError(null);

    try {
      const response = await axiosInstance.get<T>(url);
      setState?.(response.data);
      setData(response.data);
      callback?.(response.data);
    } catch (error) {
      setError(error);
    } finally {
      setLoad(false);
    }
  }, [url, setState, callback]);

  useEffect(() => {
    fetchData();
  }, [fetchData, ...rest]);

  return { data, load, error, fetchData };
};

export default useFetchData;